import React, { useContext } from 'react';
import { PageStateContext } from '../../services';
import { AnyProps } from '../types';
import { InjectBlackTriangle } from './black-triangle';

export const RocheHeadline = ({ blok, slot, getComponent }: AnyProps): JSX.Element => {
  const pageContext = useContext(PageStateContext);

  // const sanitized: HTMLElement = document.createElement('div');
  // sanitized.textContent = blok.headline.toString();
  // TODO::: We cannot use 'document' in the build process. This is the most ideal
  // For now we have to use RegEx solutions which are not perfect

  const icon = blok.icon || null;
  const size = icon && blok.size;
  const tag = icon ? 'roche-headline-with-icon' : 'roche-headline';

  return React.createElement(tag, {
    headline: InjectBlackTriangle(blok.headline, pageContext, getComponent),
    level: blok.level,
    // eslint-disable-next-line @typescript-eslint/naming-convention
    'force-level-style': blok.force_level_style,
    icon,
    size,
    ...(slot ? { slot } : {}),
    // eslint-disable-next-line no-underscore-dangle
    uid: blok._uid,
  });
};
